import React, { memo, useMemo } from 'react';
import block from 'bem-cn';
import { shallowEqual, useSelector } from 'react-redux';

import './AssistantTable.scss';

const b = block('assistant-table');

const ContextBlock = memo(function ContextBlock({ locale, context, type = null }) {
  return (
    <div className={b('context', { type })}>
      {context?.map(el => (
        <span key={el.key} className={b('context-element')}>
          {locale?.[el.key] ?? el.key}
        </span>
      ))}
    </div>
  );
});

const AssistantTable = ({ model }) => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const assistantLocale = locale?.assistantPanel ?? {};
  const { rows, tableType } = useSelector(state => state.assistant, shallowEqual);

  const {
    outputState: { fullContext },
  } = model;

  const DescriptionElement = useMemo(() => {
    const [before, after] = assistantLocale?.descriptionTop?.split('{{value}}');
    return (
      <div className={b('description')}>
        {before}
        <ContextBlock context={fullContext} type="header" locale={assistantLocale} />
        {after}
      </div>
    );
  }, [assistantLocale, fullContext]);

  const TableRowsElements = useMemo(
    () =>
      rows?.map((row, idx) => (
        <div key={'assistant-row' + idx} className={b('table-row')}>
          {row?.map(value => (
            <div key={value} className={b('table-value')}>
              {idx === 0 ? assistantLocale?.fields?.[value] ?? value : value}
            </div>
          ))}
        </div>
      )),
    [rows, assistantLocale],
  );

  return (
    <div className={b({ type: tableType })}>
      <ContextBlock context={fullContext} locale={assistantLocale} />
      {DescriptionElement}
      {rows?.length > 0 ? (
        <div className={b('table')}>{TableRowsElements}</div>
      ) : (
        <div className={b('empty')}>{locale.noResults}</div>
      )}
    </div>
  );
};

export default AssistantTable;
